export function generateRegexMatchList(regex) {
  return regex.split('&&');
}
